module.exports = __webpack_public_path__ + "static/img/qaRobot.3a6fc089.png";